<div *transloco="let t">
    <div class="w-full p-[40px] flex flex-wrap gap-x-[4%] lg:gap-x-[2%] gap-y-[40px] items-center">
        <div class="w-[48%] lg:w-[23.5%] min-h-[125px] p-[20px] rounded-[12px] shadow-lg flex flex-wrap">
            <div class="text-primary text-title flex items-center">{{t('bookingsCurrentMonth')}}:</div>
            <div class="text-primary text-title items-center flex mx-auto">{{dashboardData.bookingsCurrentMonth }}
            </div>
        </div>
        <div class="w-[48%] lg:w-[23.5%] min-h-[125px] p-[20px] rounded-[12px] shadow-lg flex flex-wrap">
            <div class="text-primary text-title flex items-center">{{t('bookingsPreviusMonth')}}:</div>
            <div class="text-primary text-title items-center flex mx-auto">{{dashboardData.bookingsPreviousMonth}}
            </div>
        </div>
        <div class="w-[48%] lg:w-[23.5%] min-h-[125px] p-[20px] rounded-[12px] shadow-lg flex flex-wrap">
            <div class="text-primary text-title flex items-center">{{t('revenueCurrentMonth')}}:</div>
            <div class="text-primary text-title items-center flex mx-auto whitespace-nowrap">€ {{dashboardData.appRevenueCurrentMonth}}
            </div>
        </div>
        <div class="w-[48%] lg:w-[23.5%] min-h-[125px] p-[20px] rounded-[12px] shadow-lg flex flex-wrap">
            <div class="text-primary text-title flex items-center">{{t('revenuePreviusMonth')}}:</div>
            <div class="text-primary text-title items-center flex mx-auto whitespace-nowrap">€ {{dashboardData.appRevenuePreviousMonth}}
            </div>
        </div>
    </div>
    <div class="w-full md:flex md:flex-wrap p-[40px] gap-x-[4%]">
        <div class="w-full md:w-[48%] shadow-xl p-4 rounded-xl">
            <div class="mb-4 text-center text-primary text-title">{{t('mostActiveUser')}}</div>
            <div class="flex">
                <div class="w-1/2 text-primary text-center text-large border-r-[1px] border-primary overflow-hidden text-ellipsis whitespace-nowrap px-2">{{t('nameSurname')}}</div>
                <div class="w-1/2 text-primary text-center text-large border-l-[1px] border-primary overflow-hidden text-ellipsis whitespace-nowrap px-2">{{t('totalBookings')}}
                </div>
            </div>
            <div class=""> @for (user of mostActive; track $index) {
                <div class="flex">
                    <div class="text-primary text-medium pt-2 border-t-[1px] border-primary overflow-hidden text-ellipsis whitespace-nowrap px-2 w-1/2 text-center border-r-[1px]" [title]="user.user.firstName + ' ' + user.user.lastName">{{user.user.firstName}}
                        {{user.user.lastName}}</div>
                    <div class="text-primary text-medium pt-2 border-t-[1px] border-primary overflow-hidden text-ellipsis whitespace-nowrap px-2 w-1/2 text-center border-l-[1px]">{{user.totalBookings}}</div>
                </div>
                }
            </div>
        </div>
        <div class="w-full md:w-[48%] shadow-xl p-4 rounded-xl">
            <div class="mb-4 text-center text-primary text-title">{{t('last5User')}}</div>
            <div class="flex">
                <div class="w-1/3 text-primary text-center text-large border-r-[1px] border-primary overflow-hidden text-ellipsis whitespace-nowrap px-2">{{t('nameSurname')}}</div>
                <div class="w-1/3 text-primary text-center text-large border-l-[1px] border-r-[1px] border-primary overflow-hidden text-ellipsis whitespace-nowrap px-2">{{t('product')}}
                </div>
                <div class="w-1/3 text-primary text-center text-large border-l-[1px] border-primary overflow-hidden text-ellipsis whitespace-nowrap px-2">{{t('date')}}
                </div>
            </div>
            <div class=""> @for (user of last5; track $index) {
                <div class="flex">
                    <div class="text-primary text-medium pt-2 border-t-[1px] border-primary overflow-hidden text-ellipsis whitespace-nowrap px-2 w-1/3 text-center border-r-[1px]" [title]="user.user.firstName">{{user.user.firstName}}
                        {{user.user.lastName}}</div>
                    <div class="text-primary text-medium pt-2 border-t-[1px] border-primary overflow-hidden text-ellipsis whitespace-nowrap px-2 w-1/3 text-center border-l-[1px] border-r-[1px]" [title]="user.item.description">{{user.item.description}}</div>
                    <div class="text-primary text-medium pt-2 border-t-[1px] border-primary overflow-hidden text-ellipsis whitespace-nowrap px-2 w-1/3 text-center border-l-[1px]">{{getFormattedDate(user.startDate)}}</div>
                </div>
                }
            </div>
        </div>
    </div>
</div>